import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';

import { SessionRefreshService } from '@app/core/services/session-refresh.service';
import { StorageService } from '@app/core/services/storage.service';

const isAuthMutation = (url: string): boolean =>
  url.includes('/api/auth/login') ||
  url.includes('/api/auth/register') ||
  url.includes('/api/auth/refresh') ||
  url.includes('/api/auth/forgot-password') ||
  url.includes('/api/auth/reset-password');

export const authRefreshInterceptor: HttpInterceptorFn = (request, next) => {
  const refreshService = inject(SessionRefreshService);
  const storage = inject(StorageService);

  if (!request.url.includes('/api/')) {
    return next(request);
  }

  const requestSession = storage.getRefreshToken();
  return next(request).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || isAuthMutation(request.url)) {
        return throwError(() => error);
      }

      const refreshToken = storage.getRefreshToken();
      if (!refreshToken || refreshToken !== requestSession) {
        return throwError(() => error);
      }

      return refreshService.refreshAccessToken().pipe(
        switchMap((token) => {
          if (!token || storage.getToken() !== token) {
            return throwError(() => error);
          }

          return next(
            request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            })
          );
        }),
        catchError(() => throwError(() => error))
      );
    })
  );
};
